import React, { useEffect, useRef } from "react";
import TagQuillEditor from "./TagQuillEditor";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";

const tags = ["firstName", "lastName", "hotelPhone", "checkinDate", "checkinTime", "checkoutDate", "checkoutTime", "magicLink", "chatLink"];

// Quill is visual only: the API and message store still receive Markdown text.
export default function MarkdownMessageEditor({ id, value = "", onChange }) {
  const { t } = useTranslation();
  const container = useRef(null);
  useEffect(() => {
    const labels = { bold: "formatBold", italic: "formatItalic", link: "formatLink", list: "messageFormatting", dynamicTag: "insertDynamicValue" };
    container.current?.querySelectorAll(".ql-toolbar button").forEach(button => {
      const format = Object.keys(labels).find(key => button.classList.contains(`ql-${key}`));
      button.type = "button";
      button.setAttribute("aria-label", t(`automation.${labels[format] || "messageFormatting"}`));
      if (format === "dynamicTag") button.title = t("automation.insertDynamicValue");
    });
  }, [t]);
  return <div ref={container} id={id} role="group" aria-label={t("automation.pushMessage")} className="markdown-message-editor">
    <TagQuillEditor value={value} onChange={onChange} tags={tags} valueFormat="markdown" style={{ minHeight: 120 }} />
    <p className="automation-editor-hint">{t("checkinFlow.common.hintTags")}</p>
  </div>;
}
